import React from "react";
import cx from "classnames";

import { Category } from "constants/events";

import DeliveryValidation from "@/components/DeliveryGateway/DeliveryValidation";
import TrackImpression from "@/components/TrackImpression";

import DeliveryScooterLogo from "../DeliveryScooterLogo";

type Props = {
  className?: string;
};

const ReadyForDelivery: React.FC<Props> = ({ className }) => (
  <TrackImpression
    category={Category.deliveryGateFlow}
    label="location_block"
    className={cx("bg-green-20 z-10", className)}
  >
    <div className="container flex justify-center py-xxl px-md">
      <div className="max-w-[488px] w-full">
        <DeliveryScooterLogo />
        <h2 className="self-center text-center text-default text-lg">
          Ready for weed delivery?
        </h2>
        <div className="box-border mt-lg">
          <DeliveryValidation
            trackingCategory={Category.deliveryGateFlow}
            trackingLabel="location block"
          />
        </div>
      </div>
    </div>
  </TrackImpression>
);

export default ReadyForDelivery;
